import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { FundPerformanceEntryComponent } from './fund-performance-entry/fund-performance-entry.component';
import { FundPerformanceCumulativeComponent } from './fund-performance-cumulative/fund-performance-cumulative.component';

@NgModule({
  imports: [CommonModule, RouterModule, FormsModule, SharedModule],
  declarations: [
    FundPerformanceEntryComponent,
    FundPerformanceCumulativeComponent,
  ],
})
export class FundPerformanceModule {}

export const fundPerformanceModuleComponentMapping = {
  'Fund Performance': FundPerformanceEntryComponent,
};
